export default __webpack_public_path__ + "assets/721159e6d974b9720af2e2bbae82e9da.jpg";